import React, { memo } from "react";
import { Badge } from "../ui/badge";
import { CalendarIcon, PhoneIcon, UserIcon } from "lucide-react";

interface ScheduledCallCardProps {
  call: {
    id: number;
    scheduled_time_ist: string;
    scheduled_time: string;
    source: string;
    call_type: string;
    profile: {
      id: number;
      name: string;
      primary_phone: string;
    };
    job: {
      id: number;
      name: string;
      position: string;
      company_name: string;
      recruitment_firm_name?: string;
    };
  };
  formatDateTime: (dateString: string, timezone?: "IST" | "UTC") => string;
}

export const ScheduledCallCard = memo(({ call, formatDateTime }: ScheduledCallCardProps) => {
  return (
    <div className="border rounded-lg p-4 space-y-3">
      <div className="flex items-start justify-between">
        <div className="space-y-2 flex-1">
          <div className="flex items-center space-x-2">
            <UserIcon className="h-4 w-4 text-muted-foreground" />
            <span className="font-medium">{call.profile.name}</span>
            <Badge variant={call.source === "internal" ? "default" : "outline"}>
              {call.source}
            </Badge>
            <Badge className="capitalize" variant="secondary">{call.call_type}</Badge>
          </div>
          
          <div className="flex items-center space-x-2">
            <PhoneIcon className="h-4 w-4 text-muted-foreground" />
            <span className="text-sm text-muted-foreground">
              {call.profile.primary_phone}
            </span>
          </div>

          <div className="space-y-1">
            <p className="font-medium text-sm">{call.job.name}</p>
            <p className="text-sm text-muted-foreground">
              {call.job.position} at {call.job.company_name}
              {call.job.recruitment_firm_name && (
                <> (via {call.job.recruitment_firm_name})</>
              )}
            </p>
          </div>
        </div>

        <div className="text-right space-y-1 ml-4">
          <div className="flex items-center space-x-2">
            <CalendarIcon className="h-4 w-4 text-muted-foreground" />
            <span className="text-sm font-medium">
              {formatDateTime(call.scheduled_time, "IST")}
            </span>
          </div>
          <p className="text-xs text-muted-foreground">
            IST: {formatDateTime(call.scheduled_time, "IST")}
          </p>
          <p className="text-xs text-muted-foreground">
            UTC: {formatDateTime(call.scheduled_time, "UTC")}
          </p>
        </div>
      </div>
    </div>
  );
});

ScheduledCallCard.displayName = "ScheduledCallCard";